import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=5780381c&scoped=true"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=5780381c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780381c",
  null
  
)

export default component.exports